import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function PainSolutionSection() {
  const pains = ['Domingo a las 23:00 armando planes que no tienen sistema', 'Siempre las mismas recetas porque no tenés banco estándar', '20 min explicando lo mismo porque no tenés material visual', 'Paciente con SOP + diabetes + HTA — improvisando', 'Instagram vacío porque no tenés tiempo ni qué publicar', 'Cobrando $12.000 cuando tu trabajo vale $35.000'];
  const solutions = ['Plan de cualquier paciente armado en 10 minutos', '120 recetas con macros calculadas listas para entregar', 'Lámina educativa que explica en 1 imagen lo que antes tardabas 20 minutos', 'Protocolo listo para cada patología — sin improvisar', '365 días de contenido de Instagram listos para publicar', 'Sistema para cobrar el doble con los mismos pacientes'];
  return <>
      {/* PAIN SECTION */}
      <section className="bg-zinc-950 text-white py-20 px-4 border-t border-zinc-900" data-id="element-110">
        <div className="max-w-4xl mx-auto" data-id="element-111">
          <div className="text-center mb-12" data-id="element-112">
            <h2 className="font-display font-black text-4xl md:text-5xl mb-6 uppercase text-red-500" data-id="element-113">
              ¿Cuántos domingos más vas a perder así?
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-114">
              Sos nutricionista. Elegiste esto por vocación. Pero nadie te dijo
              que ibas a pasar los domingos armando planes desde cero. No es
              falta de conocimiento.{' '}
              <strong className="text-white" data-id="element-115">Es falta de un sistema.</strong>
            </p>
          </div>

          <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 space-y-4" data-id="element-116">
            {pains.map((pain, i) => <div key={i} className="flex items-start gap-4" data-id="element-117">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-118" />
                <span className="text-lg text-gray-300" data-id="element-119">{pain}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="bg-white text-black py-20 px-4" data-id="element-120">
        <div className="max-w-4xl mx-auto" data-id="element-121">
          <div className="text-center mb-12" data-id="element-122">
            <h2 className="font-display font-black text-4xl md:text-5xl mb-6 uppercase text-brand" data-id="element-123">
              ¿Y si este fuera el último domingo que pasás así?
            </h2>
          </div>

          <div className="bg-brand/5 border-2 border-brand/20 rounded-2xl p-6 md:p-10 space-y-4 shadow-xl shadow-brand/5" data-id="element-124">
            {solutions.map((solution, i) => <div key={i} className="flex items-start gap-4" data-id="element-125">
                <CheckCircle2 className="w-6 h-6 text-brand shrink-0 mt-1" data-id="element-126" />
                <span className="text-lg font-medium text-gray-800" data-id="element-127">
                  {solution}
                </span>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}